import { Chip } from "@material-ui/core";
import React from "react";
import { RiskChipProps } from "./RiskChipProps";
import { riskChipStyles } from "./RiskChipStyles";

export function RiskChip({ riskLevel }: RiskChipProps) {
    const classes = riskChipStyles({ riskLevel });

    return <Chip label={riskLevel} className={classes.root} />;
}
